export default __webpack_public_path__ + "static/media/uploadImage.387bf5f3.png";